export enum FileUploadStatus {
  IN_PROGRESS = 'in-progress',
  COMPLETE = 'complete',
  ERROR = 'error',
}
